var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5218_9597)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.9997,
    cy: 23.9997,
    r: 23.9997,
    fill: "#7A9CDC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.3402 18.2108C35.5194 10.0459 23.2159 7.40994 15.3467 10.3415C21.8529 11.576 35.2821 15.7575 36.9485 22.6084C38.615 29.4593 32.551 37.5496 29.3107 40.7385C35.0198 38.8097 44.9721 30.2462 39.3402 18.2108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9103 50.4606C36.4244 50.4606 43.2747 41.4341 43.2747 29.1673C43.2747 27.154 42.7424 25.0649 41.8175 23.0048C41.9642 23.9149 42.0403 24.847 42.0403 25.796C42.0403 35.9155 36.6398 43.9017 23.6787 43.4388C13.0053 43.4388 4.54565 33.7309 4.54565 23.6114C4.54565 13.4919 12.0409 7.47296 22.7143 7.47296C23.7922 7.47296 24.8495 7.55663 25.8794 7.71749C23.9305 6.89009 22.0232 6.39601 20.2841 6.32996C6.06562 5.78987 -6.02378 14.3134 -6.02378 26.1585C-6.40952 35.6479 9.25177 50.4606 23.9103 50.4606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5974 35.0675C24.3532 39.7311 33.0999 38.7748 37.1336 32.9315C41.1674 27.0881 38.9607 18.5705 32.2049 13.9069C25.449 9.2432 16.7024 10.1995 12.6686 16.0429C8.63485 21.8862 10.8415 30.4038 17.5974 35.0675ZM20.7746 31.2976C26.2239 35.0593 33.279 34.2879 36.5327 29.5746C39.7863 24.8614 38.0064 17.991 32.5571 14.2292C27.1078 10.4675 20.0527 11.2389 16.799 15.9522C13.5453 20.6655 15.3253 27.5358 20.7746 31.2976Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.615 33.5779C30.5415 34.0941 34.3739 32.7022 36.5327 29.5749C39.7863 24.8616 38.0064 17.9912 32.5571 14.2295C28.2281 11.2411 22.8856 11.1136 19.2407 13.5504C22.0424 13.1308 25.179 13.8199 27.8978 15.6967C33.0367 19.2441 34.737 25.6915 31.6957 30.0972C30.4725 31.869 28.6688 33.0408 26.615 33.5779Z",
    fill: "#030102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2957 13.5234C23.6595 12.9906 25.1581 12.6962 26.7309 12.6962C28.6969 12.6962 30.5469 13.1563 32.1625 13.9668C27.9072 11.2357 22.7756 11.1871 19.2407 13.5505C20.2284 13.4025 21.2578 13.3923 22.2957 13.5234Z",
    fill: "#A9F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5329 29.575C34.3741 32.7023 30.5417 34.0942 26.6152 33.5781C27.8223 33.2624 28.9431 32.7274 29.9103 31.9802C34.3336 31.274 37.7189 27.3443 37.7189 22.6024C37.7189 21.8976 37.6441 21.2108 37.5022 20.5498C38.5986 23.618 38.3554 26.9349 36.5329 29.575Z",
    fill: "#A9F4F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5218_9597"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9997C0 10.745 10.745 0 23.9997 0V0C37.2544 0 47.9995 10.745 47.9995 23.9997V23.9997C47.9995 37.2544 37.2544 47.9995 23.9997 47.9995V47.9995C10.745 47.9995 0 37.2544 0 23.9997V23.9997Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSos);
export default __webpack_public_path__ + "static/media/sos.1ce130ecd98126fc9c9051f05a2116c8.svg";
export { ForwardRef as ReactComponent };